import type { Card } from "./card";

export async function pollCardStatus(
  cardId: string,
  expectedStatus: string,
  retrieveCard: (id: string) => Promise<Card>,
  {
    interval = 2000,
    maxAttempts = 10,
    requireNoPendingOperation = false,
  }: { interval?: number; maxAttempts?: number; requireNoPendingOperation?: boolean } = {},
): Promise<Card | null> {
  let attempts = 0;
  while (attempts < maxAttempts) {
    const card = await retrieveCard(cardId);
    const statusMatch = card.status === expectedStatus;
    const noPending = !requireNoPendingOperation || !card.pendingManagementOperation;
    if (statusMatch && noPending) {
      return card;
    }
    await new Promise((resolve) => setTimeout(resolve, interval));
    attempts++;
  }
  return null;
}
